// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__vaiYN","header__form":"form_header__form__kRLJt","content__form":"form_content__form__HrbvF"};